var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-8 px-5",staticStyle:{"min-height":"calc(100vh - (112px + 2.75rem))"}},[_c('div',[_c('div',{staticClass:"flex"},[_c('DriverCount'),_c('VehicleCount')],1),_c('div',{staticClass:"flex"},[_c('BusinessLinked'),_c('Notifications')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }